export default function($) {
  const offers = $('.js-rosette-offers');


  $('.js-rosette-icon').on( "mouseover touchstart", function(event) {
    event.stopPropagation();

    $('.js-cursor-animated').hide();

    const itemid = $(this).data('itemid');

    $('.js-rosette-icon').removeClass('highlighted');
    $('.js-rosette-icon').addClass('disapear');
    offers.find('.rosette-text-container').removeClass('displayed');

    $(this).removeClass('disapear');
    $(this).addClass('highlighted');
    offers.find('#rosette-text-container-'+itemid).addClass('displayed');
  });


  $(document).mouseup(function(e) {
    if( $(window).width() <= 1024 ) {
      var container = $(".js-rosette-icon, .rosette-text-container.displayed");

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.js-rosette-icon').removeClass('highlighted');
        $('.js-rosette-icon').removeClass('disapear');
        offers.find('.rosette-text-container').removeClass('displayed');
      }

    } else {
      var container = $(".js-rosette-offers");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.js-rosette-icon').removeClass('highlighted');
        $('.js-rosette-icon').removeClass('disapear');
        offers.find('.rosette-text-container').removeClass('displayed');
      }
    }
  });

  offers.mouseleave( function() {
    $('.js-cursor-animated').show();
    $('.js-rosette-icon').removeClass('highlighted');
    $('.js-rosette-icon').removeClass('disapear');
    offers.find('.rosette-text-container').removeClass('displayed');
  });

}
